import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const ArrowDown = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="vuesax/outline/arrow-down">
        <g id="arrow-down">
          <path
            id="Vector"
            d="M8.00203 14.1667C7.87536 14.1667 7.7487 14.12 7.6487 14.02L3.60203 9.97337C3.4087 9.78004 3.4087 9.46004 3.60203 9.2667C3.79536 9.07337 4.11536 9.07337 4.3087 9.2667L8.00203 12.96L11.6954 9.2667C11.8887 9.07337 12.2087 9.07337 12.402 9.2667C12.5954 9.46004 12.5954 9.78004 12.402 9.97337L8.35536 14.02C8.25536 14.12 8.1287 14.1667 8.00203 14.1667Z"
          />
          <g id="Vector_2">
            <mask id="path-2-inside-1_3025_663">
              <path d="M8 14.0534C7.72667 14.0534 7.5 13.8267 7.5 13.5534V2.33337C7.5 2.06004 7.72667 1.83337 8 1.83337C8.27333 1.83337 8.5 2.06004 8.5 2.33337V13.5534C8.5 13.8267 8.27333 14.0534 8 14.0534Z" />
            </mask>
            <path d="M8 14.0534C7.72667 14.0534 7.5 13.8267 7.5 13.5534V2.33337C7.5 2.06004 7.72667 1.83337 8 1.83337C8.27333 1.83337 8.5 2.06004 8.5 2.33337V13.5534C8.5 13.8267 8.27333 14.0534 8 14.0534Z" />
            <path
              d="M8 13.0534C8.27895 13.0534 8.5 13.2744 8.5 13.5534H6.5C6.5 14.379 7.17438 15.0534 8 15.0534V13.0534ZM8.5 13.5534V2.33337H6.5V13.5534H8.5ZM8.5 2.33337C8.5 2.61233 8.27895 2.83337 8 2.83337V0.833374C7.17438 0.833374 6.5 1.50776 6.5 2.33337H8.5ZM8 2.83337C7.72105 2.83337 7.5 2.61233 7.5 2.33337H9.5C9.5 1.50776 8.82562 0.833374 8 0.833374V2.83337ZM7.5 2.33337V13.5534H9.5V2.33337H7.5ZM7.5 13.5534C7.5 13.2744 7.72105 13.0534 8 13.0534V15.0534C8.82562 15.0534 9.5 14.379 9.5 13.5534H7.5Z"
              mask="url(#path-2-inside-1_3025_663)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

ArrowDown.displayName = 'ArrowDown';
